<template>
  <div class="c-price-filter">
    <div class="c-price-filter__slider-container">
      <vue-slider
        v-if="!isServer"
        ref="slider"
        v-model="value"
        :enable-cross="true"
        dot-size="26"
        tooltip-placement="bottom"
        :tooltip-formatter="valueCurrency"
        :min="min"
        :max="max"
        :dot-options="dotOptions"
        :rail-style="railStyle"
        :process-style="processStyle"
        :interval="interval"
        :use-keyboard="true"
        :lazy="true"
      />
    </div>
    <div class="c-price-filter-input">
      <button 
        class="u-sr-only"
        role="paragraph"
      >
        minimum price you want
      </button>
      <text-input
        id="minPriceWant"
        v-model="minPriceInput"
        placeholder="min"
      />
      <button 
        class="u-sr-only"
        role="paragraph"
      >
        maximum price you want
      </button>
      <text-input
        id="maxPriceWant"
        v-model="maxPriceInput"
        placeholder="max"
      />
    </div>
  </div>
</template>

<script>
// import VueSlider from 'vue-slider-component'
import VueSlider from 'vue-slider-component/dist-css/vue-slider-component.umd.min.js'
import 'vue-slider-component/dist-css/vue-slider-component.css'
import TextInput from "../inputs/TextInput.vue"

export default {
  name: 'PriceFilter',
  components: {
    VueSlider,
    TextInput
  },
  props: {
    priceRangeFilters: {
      type: Array,
      default () {}
    },
    activePriceRange: {
      type: Object,
      default () {}
    },
  },
  data () {
    return {
      interval: 0.01,
      dotOptions: {
        'tooltip': 'always',
        'style': {
          'background': '#022840',
          'border-radius': '50%',
          'border': '2px solid #022840',
          'box-shadow': 'inset 0 0 0 0.15rem white, 0.5px 0.5px 2px 1px rgba(0,0,0,.32)',
          'height': '22px',
          'width': '22px'
        },
        'tooltipStyle': {
          'background': 'none',
          'color': 'black',
          'box-shadow': 'none',
          'font-weight': '400',
          'letter-spacing': '2.15px'
        }
      },
      railStyle: {
        'background': '#fff',
        'border': '1px solid #DBDFE3',
        'border-radius': '15px'
      },
      processStyle: {
        'background': '#EBEBEB' 
      },
      valueCurrency: vC => {
        return '$' + parseFloat(vC).toFixed(2)
      },
      minPriceInput: null,
      maxPriceInput: null,
    }
  },
  computed: {
    value: {
      get() {
        const activeFilter = this.activePriceRange
        let result = []
        if (activeFilter) {
          if(parseFloat(this.maxPriceInput) >= parseFloat(this.minPriceInput)) {
            result.push(
              (this.minPriceInput ? parseFloat(this.minPriceInput) : parseFloat(activeFilter.range[0])).toFixed(2),
              (this.maxPriceInput ? parseFloat(this.maxPriceInput) : parseFloat(activeFilter.range[1])).toFixed(2)
            )
          } else {
            result.push(parseFloat(activeFilter.range[0]).toFixed(2), parseFloat(activeFilter.range[1]).toFixed(2));
          }
        } else {
          if(parseFloat(this.maxPriceInput) >= parseFloat(this.minPriceInput)) {
            result.push(
              (this.minPriceInput ? parseFloat(this.minPriceInput) : parseFloat(this.min)).toFixed(2),
              (this.maxPriceInput ? parseFloat(this.maxPriceInput) : parseFloat(this.max)).toFixed(2)
            )
          } else {
            result.push(parseFloat(this.min).toFixed(2), parseFloat(this.max).toFixed(2));
          }
        }
        return result
      },
      set(value) {
        const [ min, max ] = value.map((n) => parseFloat(n).toFixed(2))
        this.$emit('input', {
          label: `$${min} - $${max}`,
          range: [...value]
        })
        this.minPriceInput = value[0], this.maxPriceInput = value[1];
      }
    },
    isServer () {
      return !!process.server
    },
    min () {
      return Math.min(
        ...this.getRange(
          this.priceRangeFilters
        )
      )
    },
    max () {
      return Math.max(
        ...this.getRange(
          this.priceRangeFilters
        )
      )
    },
  },
  watch: {
    minPriceInput(value) {
      if(parseFloat(value) <= parseFloat(this.maxPriceInput))
      {
        this.$emit('input', {
          label: `$${value} - $${this.maxPriceInput}`,
          range: [value, this.maxPriceInput]
        })
      }
    },
    maxPriceInput(value) {
      if(parseFloat(value) >= parseFloat(this.minPriceInput))
      {
        this.$emit('input', {
          label: `$${this.minPriceInput} - $${value}`,
          range: [this.minPriceInput, value]
        })
      }
    }
  },
  methods: {
    getRange (filters) {
      let result = [0]
      if (filters) {
        result = []
        for (let { range } of filters) {
          for (let n of range) {
            result.push(parseFloat(n))
          }
        }
      }
      return result
    }
  }
}
</script>

<style lang="scss" scoped>
.c-price-filter {
  padding-top: rem(20px);
  padding-bottom: rem(30px);
  &-input {
    display: flex;
    padding-top: rem(30px);
  }
  &__slider-container {
    padding: 0 rem(45px);
  }
}
</style>
